import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import Loading from '../Loading';
import useAccesoEvento from './useAccesoEvento';

const ProtectedRoute = ({ component: Component, allowedRoles, ...rest }) => {
  const { id } = useParams();
  const { cargando, permitido } = useAccesoEvento(id, allowedRoles);

  if (cargando) return <Loading />;
  if (!permitido) return <Redirect to="/unauthorized" />;
  return <Component {...rest} />;
};

export default ProtectedRoute;
